import React from "react";
import TaxInvoiceLegacyPanel from "./TaxInvoiceLegacyPanel";
import "./TaxInvoiceReconciliationPage.css";

export default function TaxInvoiceLegacyPage() {
  return (
    <main className="tax-reconciliation-page">
      <header className="tax-reconciliation-page__header">
        <div>
          <p className="tax-reconciliation-eyebrow">Quản trị hóa đơn điện tử</p>
          <h1>Đối soát hóa đơn BKAV</h1>
          <p>Đặt lịch hoặc đối soát ngay cho bản update tax cũ.</p>
        </div>
      </header>
      <TaxInvoiceLegacyPanel />
    </main>
  );
}
